import { useForgotPassword } from '@goparrot-dashboard-api/auth';
import { PageTitle, PositiveFeedback, useNotifications } from '@goparrot-dashboard/shared-ui';
import * as React from 'react';
import { useI18n } from '@goparrot-dashboard/i18n';
import { ForgotPasswordForm } from '../forms/ForgotPasswordForm';
import { SignInSubtitle } from '../components/SignInSubtitle';

/**
 * @description Page where to request forgot password email
 */
export const ForgotPasswordPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { getIntlString } = useI18n();
  const { notifyError } = useNotifications();

  const forgotPassword = useForgotPassword({
    onError: () => {
      notifyError({
        text: getIntlString('error.resetPassword'),
      });
    },
  });

  return (
    <>
      <header>
        <PageTitle hasMargin={false} fontWeight="medium" seoTitle={getIntlString('title.resetPassword')}>
          {getIntlString('title.forgotPassword')}
        </PageTitle>
        <SignInSubtitle />
      </header>
      <section className="tw-mt-4 tw-relative">
        {forgotPassword?.data?.ok ? (
          <div>
            <PositiveFeedback title={getIntlString('feedback.reset.title')} subtitle={getIntlString('feedback.reset.subtitle')} />
          </div>
        ) : (
          <ForgotPasswordForm onSubmit={(payload) => forgotPassword.mutate(payload)} isFormLoading={forgotPassword.isLoading} />
        )}
      </section>
    </>
  );
};
